import PaymentsIcon from "@mui/icons-material/Payments";
import RedirectToTab from "../RedirectToCampaignTab";
import ListPaidCampaigns from "./List";
import { CAMPAIGNS, CandidateServicePath, PAID } from "utils/constants";
import CreatePaidCampaign from "./Create";
import EditPaidCampaign from "./Edit";
import permissions from "app/permissions";
import ShowPaidCampaign from "./Show";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  icon: <PaymentsIcon />,
  name: CandidateServicePath + CAMPAIGNS + `/${PAID}`,
  title: "Платени кампании",
  list: <RedirectToTab type={PAID} />,
  tabList: <ListPaidCampaigns />,
  create: <CreatePaidCampaign />,
  createPermission: permissions.canCreateCampaigns,
  edit: <EditPaidCampaign />,
  editPermission: permissions.canUpdateCampaigns,
  show: <ShowPaidCampaign />,
  showPermission: permissions.canPreviewCampaigns,
  permission: permissions.canPreviewCampaigns,
};
